<template>
  <div class="container mt-4">
    <h2>編輯</h2>
    <form >
        <div class="form-group">
          <label for="name">主題</label>
          <input v-model="eventDefine2.name" type="text" class="form-control" required>
        </div>
        <div class="form-group">
          <label for="price">日期</label>
          <input v-model="eventDefine2.eventDt" type="date" class="form-control" required>
        </div>

        <div class="form-group">
          <label for="description">內容</label>
          <MyCkEditor v-model="eventDefine2.eventContent" height="600px" width="800px" ></MyCkEditor>
        </div>


      <div class="form-group">
        <label for="description">人數上限</label>

        <div class="checkbox">
          <label><input type="radio" value="0" v-model.number="eventDefine2.applicant_limit_type" :checked="eventDefine2.applicant_limit_type === 0">不限</label>
        </div>
        <div class="checkbox">
          <label><input type="radio" value="1" v-model.number="eventDefine2.applicant_limit_type" :checked="eventDefine2.applicant_limit_type === 1">限制</label>
        </div>
        <div class="" v-if="eventDefine2.applicant_limit_type===1">
          <input v-model.number="eventDefine2.applicant_limit" type="number" class="form-control" required>人
        </div>
      </div>

      <input v-model="eventDefine2.status" type="hidden" class="form-control" value="0">

        <button type="button" class="btn btn-primary" @click="saveData">保存</button>
        <button type="button" class="btn btn-info" @click="goback">回上一頁</button>
    </form>
  </div>
</template>

<script>
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";

export default {
  components: { MyCkEditor},
  data() {
    return {
      id:"",
      eventDefine2: {
        id: null,
        status: '',
        group_name: '',
        name: '',
        eventDt: '',
        eventContent: '',
        applicant_limit_type: 0,
        applicant_limit: 0,
        memo: '',
      },
    };
  },
  mounted() {
    this.id=this.$route.query.id
    this.loadDatas();
  },
  methods: {
    async loadDatas() {
      let that=this;
      // 假設產品ID從路由參數中獲取
      const id = this.id;

      if (id){
        apiFireGodsec.api_Admin_EventDefine2_Get(id).then((data)=>{
          that.eventDefine2 = data.data.data;
        })
      }
    },
    goback() {
      // this.$router.go(-1);
      this.$router.push({ name: 'EventDefine2List' });
    },
    async saveData() {
      try {
        //validate by client
        if (!this.eventDefine2.name) {
          alert('請輸入名稱');
          return;
        }
        if (!this.eventDefine2.eventDt) {
          alert('請輸入日期');
          return;
        }
        if (this.eventDefine2.applicant_limit_type ===1) {
          if (this.eventDefine2.applicant_limit <=0) {
            alert('人數上限不能小於0');
            return;
          }
        }

        apiFireGodsec.api_Admin_EventDefine2_Save(this.eventDefine2).then((data)=> {  // eslint-disable-line
          alert('儲存成功');
        })

      } catch (error) {
        console.error('保存失敗', error);
        alert('保存失敗');
      }
    }
  }
};
</script>

<style scoped>
/* 可以在這裡添加自定義樣式 */
</style>
